import React from 'react';
import {Tab} from "semantic-ui-react";
import ContractDetails from "./contract-details";
import ContractTrades from "./contract-trades";
import ContractTradeStrats from "./contract-trade-strats";
import ContractVolumes from "./contract-volumes";
import ContractTradePosition from "./contract-trading-position";

class ContractDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    panes = [
        { menuItem: 'Details', render: () => <Tab.Pane><ContractDetails contractData={this.props.contract}/></Tab.Pane> },
        { menuItem: 'Volumes', render: () => <Tab.Pane><ContractVolumes customerId={this.props.customerId} contractId={this.props.contract.contractId}/></Tab.Pane> },
        { menuItem: 'Trades', render: () => <Tab.Pane><ContractTrades customerId={this.props.customerId} contractId={this.props.contract.contractId}/></Tab.Pane> },
        { menuItem: 'Trading Strategies', render: () => <Tab.Pane><ContractTradeStrats customerId={this.props.customerId} contractId={this.props.contract.contractId}/></Tab.Pane> },
        { menuItem: 'Trading Position', render: () => <Tab.Pane><ContractTradePosition customerId={this.props.customerId} contractId={this.props.contract.contractId}/></Tab.Pane> },
    ];

    render() {
        return (
            <Tab panes={this.panes} />
        );
    }
}

export default ContractDetailsContainer;